export const VCS_REVISION = process.env.REACT_APP_VCS_REVISION || "Development";
